import shiftAcceptanceBulkButtonComponentHtml from './shiftAcceptanceBulkButtonComponent.html';

class ShiftAcceptanceBulkButtonCtrl {
  hasPendingShiftSelected = false;
  hasOtherEmployeesShiftSelected = false;
  hasRejectedShiftSelected = false;

  constructor(
    Authentication,
    AlertService,
    EventCollection,
    ShiftAcceptanceUtils,
    pluralizeFilter
  ) {
    'ngInject';

    Object.assign(this, {
      Authentication,
      AlertService,
      EventCollection,
      ShiftAcceptanceUtils,
      pluralizeFilter,
    });
  }

  $onChanges(changes) {
    if (changes.selectionChangesCount) {
      this.refreshHasOtherEmployeesShiftSelected();
      this.refreshHasRejectedShiftSelected();
      this.refreshHasPendingShiftSelected();
    }
  }

  get isBulkDisabled() {
    return this.hasOtherEmployeesShiftSelected || this.hasRejectedShiftSelected;
  }

  refreshHasOtherEmployeesShiftSelected() {
    const conditionFn = (e) => !e.user || e.user.id !== this.Authentication.user.id;
    this.hasOtherEmployeesShiftSelected = this.checkInEventsCollection(conditionFn);
  }

  refreshHasRejectedShiftSelected() {
    const conditionFn = (e) => this.ShiftAcceptanceUtils.isRejectedStatus(e);
    this.hasRejectedShiftSelected = this.checkInEventsCollection(conditionFn);
  }

  refreshHasPendingShiftSelected() {
    const conditionFn = (e) => this.ShiftAcceptanceUtils.isPendingAcceptance(e);
    this.hasPendingShiftSelected = this.checkInEventsCollection(conditionFn);
  }

  checkInEventsCollection(conditionFn) {
    return Object.keys(this.selectedEvents).some((id) => {
      if (!this.selectedEvents[id]) {
        return false;
      }

      const shift = this.EventCollection.allEvents.find((event) => event.id === id);
      return shift && conditionFn(shift);
    });
  }

  shouldShowButton() {
    return (
      this.hasSelectedEvents &&
      this.ShiftAcceptanceUtils.isShiftAcceptanceEnabled() &&
      this.hasPendingShiftSelected
    );
  }

  getTooltip() {
    if (this.hasOtherEmployeesShiftSelected) {
      return 'You can only accept your own shifts';
    }

    if (this.hasRejectedShiftSelected) {
      return 'You cannot accept rejected shifts';
    }

    return 'Accept shifts';
  }

  async acceptShifts() {
    const shiftIds = Object.keys(this.selectedEvents)
      .map((id) => {
        const event =
          this.selectedEvents[id] && this.EventCollection.allEvents.find((e) => e.id === id);
        return event?.id && this.ShiftAcceptanceUtils.isPendingAcceptance(event) ? event.id : null;
      })
      .filter(Boolean);

    if (!shiftIds.length) {
      return;
    }

    await this.EventCollection.bulkAcceptShifts(shiftIds);
    this.AlertService.success(
      `You have accepted ${shiftIds.length > 1 ? shiftIds.length : 'a'} ${this.pluralizeFilter(
        shiftIds,
        'shift',
        'shifts'
      )}`
    );
    this.selectedEvents = {};
  }
}

export default {
  controller: ShiftAcceptanceBulkButtonCtrl,
  controllerAs: 'ctrl',
  bindings: {
    hasSelectedEvents: '<',
    selectedEvents: '=',
    selectionChangesCount: '<',
  },
  templateUrl: shiftAcceptanceBulkButtonComponentHtml,
};
